import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function AddOrder() {
  const navigate = useNavigate();
  const [order, setOrder] = useState({ externalOrderId: '', status: 'NEW', channel: 'WEBSITE' });

  const handleSubmit = (e) => {
    e.preventDefault();
    api(`/orders`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(order),
    })
      .then(res => res.json())
      .then(data => navigate(`/inventory/orders/${data.id}`, { state: { saved: true } }));
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow p-6">
            <h1 className="text-2xl font-bold text-gray-900 mb-6">Add Order</h1>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">External Order ID</label>
                <input
                  type="text"
                  value={order.externalOrderId}
                  onChange={(e) => setOrder({ ...order, externalOrderId: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Channel</label>
                <select
                  value={order.channel}
                  onChange={(e) => setOrder({ ...order, channel: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
                >
                  <option value="WEBSITE">Website</option>
                  <option value="EBAY">eBay</option>
                  <option value="AMAZON">Amazon</option>
                </select>
              </div>
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                <select
                  value={order.status}
                  onChange={(e) => setOrder({ ...order, status: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-600"
                >
                  <option value="NEW">New</option>
                  <option value="PENDING_FULFILLMENT">Pending Fulfillment</option>
                  <option value="FULFILLED">Fulfilled</option>
                  <option value="CANCELLED">Cancelled</option>
                </select>
              </div>
              <div className="flex gap-3">
                <button type="submit" className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">
                  Save
                </button>
                <button type="button" onClick={() => navigate('/inventory/orders')} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                  Cancel
                </button>
              </div>
            </form>
      </div>
    </Layout>
  );
}
